import script from "./FloatingInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingInput.vue?vue&type=script&setup=true&lang=js"

import "./FloatingInput.vue?vue&type=style&index=0&id=577070a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577070a6"]])

export default __exports__